import React from 'react';
import { Check } from 'lucide-react';

const STEPS = ['Service', 'Home Details', 'Schedule', 'Add-Ons', 'Checkout'];

export const BookingProgress = ({ step }) => (
  <div className="flex justify-center mb-8" data-testid="progress-bar">
    <div className="flex items-center gap-1 sm:gap-2">
      {STEPS.map((label, i) => {
        const done = step > i + 1;
        const active = step === i + 1;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center gap-1">
              <div
                className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all ${
                  done
                    ? 'bg-[#F56F05] text-white'
                    : active
                      ? 'bg-[#F56F05] text-white ring-4 ring-[#F56F05]/20'
                      : 'bg-zinc-200 text-zinc-500'
                }`}
                data-testid={`progress-${i + 1}`}
              >
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <span
                className={`text-[10px] sm:text-xs font-medium hidden sm:block ${
                  active || done ? 'text-[#F56F05]' : 'text-zinc-400'
                }`}
              >
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={`w-8 sm:w-14 h-1 rounded-full mt-[-18px] sm:mt-[-20px] ${
                  done ? 'bg-[#F56F05]' : 'bg-zinc-200'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  </div>
);
